// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import BoardEdit from 'app/common/react/components/BoardEdit/BoardEdit';
import i18n from 'app/common/lib/i18n';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyModal from 'app/common/react/ui/deprecated/LegacyModal';
import type { BoardEditType } from 'app/common/react/components/BoardEdit/BoardEdit';
import type { State as ReduxState } from 'app/common/redux/reducers/types';
import withResource from 'app/common/lib/react/withResource';
import { compose } from 'redux';
import { Spinner } from 'gestalt';

type OwnProps = {|
  boardId: string,
  coverImageHeight?: number,
  coverImageWidth?: number,
  onBoardArchiveChange: () => void,
  onBoardDelete: Function,
  onBoardPrivacyChange?: Function | null,
  onBoardLeave?: (boardId: string) => void,
  onBoardUpdate?: (boardId: string, updatedFields: Object) => void,
  onClose: Function,
  onCropChange?: Function | null,
|};

type ReduxProps = {
  board: ?BoardEditType,
};

type Props = OwnProps &
  ReduxProps & {
    categoriesResource: {
      data: Array<{
        key: string,
        name: string,
      }>,
    },
  };

export function BoardEditModal(props: Props) {
  const {
    board,
    coverImageHeight,
    coverImageWidth,
    categoriesResource: { data: categories },
    onBoardArchiveChange,
    onBoardPrivacyChange,
    onBoardLeave,
    onBoardDelete,
    onBoardUpdate,
    onClose,
    onCropChange,
  } = props;
  const resourceLoaded = !!(board && categories);
  const modalClassName = 'BoardEdit BoardEditBase';
  if (!resourceLoaded) {
    return (
      <LegacyModal className={modalClassName}>
        <Spinner accessibilityLabel={i18n._('Board edit')} show />
      </LegacyModal>
    );
  }

  return (
    <LegacyModal className={modalClassName} onHide={onClose}>
      <BoardEdit
        board={board}
        categories={categories}
        coverImageHeight={coverImageHeight}
        coverImageWidth={coverImageWidth}
        onBoardArchiveChange={onBoardArchiveChange}
        onBoardPrivacyChange={onBoardPrivacyChange}
        onBoardLeave={onBoardLeave}
        onBoardDelete={onBoardDelete}
        onBoardUpdate={onBoardUpdate}
        onClose={onClose}
        onCropChange={onCropChange}
      />
    </LegacyModal>
  );
}

export default compose(
  withResource(
    {
      name: 'CategoriesResource',
      key: 'categoriesResource',
    },
    { allowStale: false },
  ),
  withResource(
    {
      name: 'BoardResource',
      key: 'boardResource',
      options: (props: OwnProps) => ({
        field_set_key: 'edit',
        board_id: props.boardId,
      }),
    },
    { allowStale: false },
  ),
  connect(
    (state: ReduxState, props: OwnProps): $Exact<ReduxProps> => ({
      board: state.boards.content[props.boardId],
    }),
  ),
)(BoardEditModal);
